export default {
  namespaced: true,
  state: {
    // Данные заказа на пополнение
    robloxNickname: '',
    robloxUserId: '',
    robuxAmount: 0,
    amount: 0,
    currency: '',
    email: '',
    selectedMethod: {
      name: '',
      key: '',
      commission: 0,
      iconType: '',
      iconName: ''
    },
    commissionValue: 0,
    totalToPay: 0,
    placeId: '',
    placeName: '',
    placeUniverseId: '',
    promoCode: '',
    // Данные SuperPass
    isSuperPass: false,
    superPassId: ''
  },
  mutations: {
    setOrderData(state, data) {
      Object.assign(state, data)
    },
    setRobloxData(state, { nickname, userId }) {
      state.robloxNickname = nickname
      state.robloxUserId = userId || ''
    },
    setRobuxAmount(state, amount) {
      state.robuxAmount = amount
    },
    setAmount(state, amount) {
      state.amount = amount
    },
    setEmail(state, email) {
      state.email = email
    },
    setSelectedMethod(state, method) {
      state.selectedMethod = { ...method }
    },
    setCommission(state, commission) {
      state.commissionValue = commission
    },
    setTotalToPay(state, total) {
      state.totalToPay = total
    },
    setCurrency(state, currency) {
      state.currency = currency
    },
    setPlaceData(state, { placeId, placeName, placeUniverseId }) {
      state.placeId = placeId
      state.placeName = placeName
      state.placeUniverseId = placeUniverseId || ''
    },
    setPromoCode(state, promoCode) {
      state.promoCode = promoCode || ''
    },
    setSuperPassData(state, { isSuperPass, superPassId }) {
      state.isSuperPass = isSuperPass || false
      state.superPassId = superPassId || ''
    },
    clearOrderData(state) {
      state.robloxNickname = ''
      state.robloxUserId = ''
      state.robuxAmount = 0
      state.amount = 0
      state.currency = ''
      state.email = ''
      state.selectedMethod = {
        name: '',
        key: '',
        commission: 0,
        iconType: '',
        iconName: ''
      }
      state.commissionValue = 0
      state.totalToPay = 0
      state.placeId = ''
      state.placeName = ''
      state.placeUniverseId = ''
      state.promoCode = ''
      state.isSuperPass = false
      state.superPassId = ''
    }
  },
  getters: {
    orderData: state => state,
    robloxNickname: state => state.robloxNickname,
    robuxAmount: state => state.robuxAmount,
    totalToPay: state => state.totalToPay,
    isSuperPass: state => state.isSuperPass,
    superPassId: state => state.superPassId
  },
  actions: {
    async makeOrder({ state, rootState, rootGetters }, { withReplenish = false } = {}) {
      // flag: true - transfer/depot (додеп), false - обычное пополнение
      const flag = withReplenish
      let order = null

      // Проверяем метод оплаты - SuperPass
      if (state.isSuperPass && state.superPassId) {
        const { makeOrderSuperPass } = await import('@/utils/orderApi')
        const currency = state.currency || rootState.currency || 'RUB'
        order = await makeOrderSuperPass(state.superPassId, state.robloxNickname || '', flag, currency.toUpperCase())
      } else {
        if (!state.placeId || !state.robloxNickname) return null

        const { makeOrderTransfer } = await import('@/utils/orderApi')
        order = await makeOrderTransfer(
          state.robuxAmount,
          state.placeId,
          state.placeUniverseId,
          state.robloxNickname,
          state.promoCode,
          flag
        )
      }

      return order
    }
  }
}
